
import { ref } from '@nuxtjs/composition-api';
import useTracking from '@/composable/tracking/useTracking'

export default {
  name: 'ProductDetailsImageGallery',
  props: {
    images: {
      type: Array,
      default: () => []
    }
  },
  setup(_props, { emit }) {
    const { track } = useTracking()
    const photoModel = ref(0)

    const carouselChange = (val) => {
      photoModel.value = val
    }

    const imageArrowClick = (data) => {
      emit('image-arrow-click', data)
    }

    return {
      imageArrowClick,
      track,
      photoModel,
      carouselChange
    }
  }
}
